import IcoMoon, { IconProps } from 'react-icomoon';
import iconSet from './selection.json';

const Icon = (props: IconProps) => {
  return <IcoMoon iconSet={iconSet} removeInlineStyle={true} {...props} />;
};

export default Icon;
